import React from 'react';
import { Product } from '../types';
import { Star, ShoppingCart } from 'lucide-react';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-all duration-300 group" data-id="element-147">
      <div className="relative aspect-square overflow-hidden bg-gray-100" data-id="element-148">
        <img src={product.imageUrl} alt={product.name} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-149" />
        <button className="absolute bottom-3 right-3 bg-white p-2 rounded-full shadow-md hover:bg-kithward-700 hover:text-white transition-colors text-gray-700" data-id="element-150">
          <ShoppingCart className="w-5 h-5" data-id="element-151" />
        </button>
      </div>

      <div className="p-4" data-id="element-152">
        <div className="flex items-center gap-1 mb-2" data-id="element-153">
          <Star className="w-4 h-4 text-amber-400 fill-current" data-id="element-154" />
          <span className="text-sm font-medium text-gray-600" data-id="element-155">
            {product.rating}
          </span>
        </div>

        <h3 className="font-bold text-gray-900 mb-1 line-clamp-1 group-hover:text-kithward-700 transition-colors" data-id="element-156">
          {product.name}
        </h3>

        <p className="text-lg font-bold text-gray-900" data-id="element-157">
          ${product.price.toFixed(2)}
        </p>
      </div>
    </div>;
}